import React, { useEffect } from "react";

const useIframeCommunicator = (path?: string) => {
  const [message, setMessage] = React.useState<any>(null);
  const send = (data: any) => {
    window.parent.postMessage(data, path || "*");
  };
  useEffect(() => {
    window.addEventListener("message", (event) => {
      setMessage(event.data);
    });

    return () => {
      window.removeEventListener("message", () => {});
    };
  }, []);
  return [message, send];
};

export default useIframeCommunicator;
